import { createActionCreator, createReducer } from 'deox';
import { SceneVolume, Volume } from 'types/sceneVolume';
import { omit } from 'ramda';
import { AppState } from 'types/AppState';

const defaultState: SceneVolume = {};
const createDefaultSceneVolume = (id: string): Volume => ({
  id,
  volume: 0.5
});

export const createSceneVolume = createActionCreator(
  'SCENES_VOLUME/CREATE',
  resolve => (id: string) => resolve(id)
);
export const deleteSceneVolume = createActionCreator(
  'SCENES_VOLUME/DELETE',
  resolve => (id: string) => resolve(id)
);

export const updateSceneVolume = createActionCreator(
  'SCENES_VOLUME/UPDATE',
  resolve => (id: string, value: number) => resolve({ id, value })
);

export const sceneVolume = createReducer(defaultState, handle => [
  handle(createSceneVolume, (state, { payload }) => ({
    ...state,
    [payload]: createDefaultSceneVolume(payload)
  })),
  handle(deleteSceneVolume, (state, { payload }) => omit([payload], state)),
  handle(updateSceneVolume, (state, { payload: { id, value } }) => ({
    ...state,
    [id]: { id, volume: value }
  }))
]);

export const getSceneVolume = (state: AppState): SceneVolume => state.sceneVolume;
